import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/interactive/img-android-1.jpg'
import _imports_1 from '../../assets/interactive/img-android-2.jpg'
import _imports_2 from '../../assets/interactive/img-ios-1.jpg'
import _imports_3 from '../../assets/interactive/img-ios-2.jpg'


const _hoisted_1 = { class: "setting" }
const _hoisted_2 = { class: "setting__title-text" }
const _hoisted_3 = { class: "phone" }
const _hoisted_4 = { class: "phone__details" }
const _hoisted_5 = { class: "phone__details-text" }
const _hoisted_6 = { class: "phone__details" }
const _hoisted_7 = { class: "phone__details-text" }
const _hoisted_8 = { class: "phone" }
const _hoisted_9 = { class: "phone__details" }
const _hoisted_10 = { class: "phone__details-text" }
const _hoisted_11 = { class: "phone__details" }
const _hoisted_12 = { class: "phone__details-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('settingText')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('forAndroid')), 1),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "phone__details-number" }, "1", -1)),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('openGoogleApp')), 1)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      class: "picture",
      id: "image1",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "phone__details-number" }, "2", -1)),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('clickTrimming')), 1)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("img", {
      class: "picture",
      id: "image2",
      src: _imports_1
    }, null, -1)),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('forIphone')), 1),
    _createElementVNode("div", _hoisted_9, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "phone__details-number" }, "1", -1)),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('openPhotoIos')), 1)
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("img", {
      class: "picture",
      id: "image3",
      src: _imports_2
    }, null, -1)),
    _createElementVNode("div", _hoisted_11, [
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "phone__details-number" }, "2", -1)),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('clickTrimmingIos')), 1)
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("img", {
      class: "picture",
      id: "image4",
      src: _imports_3
    }, null, -1)),
    _createVNode(_component_Button, {
      class: "button",
      size: 'large',
      text: _ctx.$t('previous'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
    }, null, 8, ["text"])
  ]))
}